interface MessageImagesProps {
  /** Image URLs to display. */
  urls: string[];
}

/**
 * Displays images that were sent with a message.
 * Takes plain URLs — use `extractImageUrls(content)` to get them from MessageContent.
 */
export function MessageImages({ urls }: MessageImagesProps) {
  if (urls.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 mt-2" data-testid="message-images">
      {urls.map((url, i) => (
        <div
          key={url + String(i)}
          className="relative w-[110px] h-[104px] rounded-lg overflow-hidden border border-neutral-200"
        >
          <img
            src={url}
            alt="Attached image"
            className="w-full h-full object-cover"
          />
        </div>
      ))}
    </div>
  );
}
